export class GetTableDataQualityDistributionColumnResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "DistributionColumn",
            "format": ""
        },
        {
            "name": "breakdown",
            "baseName": "breakdown",
            "type": "Array<DistributionBucket>",
            "format": ""
        },
        {
            "name": "trend",
            "baseName": "trend",
            "type": "DistributionTrend",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityDistributionColumnResponse.attributeTypeMap;
    }
    constructor() {
    }
}
